/**
 * @typedef {{
*  storeData?: any
* }} OfficialStoreState
*/

export default () => ({
  storeData: null,
})
